import React from 'react';
import ModalFormUI from '../../../widgets/form/ModalFormUI';
import InputTextSF from '../../../widgets/form/InputTextSF';
import InputSelectSF from '../../../widgets/form/InputSelectSF';
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI';

const SalesTargetUpdateModalUI = ({
    context, successMsg, errorList, setErrorList, submitted,
    updateMode, onSubmit, onCancelClick,
    userName, salesTargetId,
    //form fields
    monthName,
    userId, onUserIdChange, userIdError, setUserIdError, userIdList,
    month, onMonthChange, monthError, setMonthError, monthList,
    year, onYearChange, yearError, setYearError, yearList,
    noOfContacts, onNoOfContactsChange, noOfContactsError, setNoOfContactsError,
    newLeadTarget, onNewLeadTargetChange, newLeadTargetError, setNewLeadTargetError,
    newDisbTarget, onNewDisbTargetChange, newDisbTargetError, setNewDisbTargetError,
    numberOfCustomers, onNumberOfCustomersChange, numberOfCustomersError, setNumberOfCustomersError,
    contactsAchieved, onContactsAchievedChange, contactsAchievedError, setContactsAchievedError,
    newLeadAchieved, onNewLeadAchievedChange, newLeadAchievedError, setNewLeadAchievedError,
    newDisbAchieved, onNewDisbAchievedChange, newDisbAchievedError, setNewDisbAchievedError,
    customersAchieved, onCustomersAchievedChange, customersAchievedError, setCustomersAchievedError,


}) => (
    <ModalFormUI
        context={context}
        titleLabel='Update Sales Target'
        buttonLabel="Update"
        cancelLabel="Cancel"
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <div className='g_flex_h g_flex_top'>
        <div className='cols g_m_right_100'>
        <InputReadOnlyUI name="user" label="UserName"
            value={userName}
        />
        <InputReadOnlyUI name="year" label="Year"
            value={year}
        />
        <InputReadOnlyUI name="month" label="Month"
            value={monthName}
        />
        </div>
        <div className='cols g_m_right_100'>
        <InputTextSF type="text" name="noOfContacts" label="Number of Contacts"
                maxLength={40} required={true} value={noOfContacts}
                onChange={onNoOfContactsChange} error={noOfContactsError} setError={setNoOfContactsError}
        />
        <InputTextSF type="number" name="newLeadTarget"
            label="New Lead Target" required={true} value={newLeadTarget}
            onChange={onNewLeadTargetChange} error={newLeadTargetError} setError={setNewLeadTargetError}
        />

        <InputTextSF type="number" name="newDisbTarget"
            label="New Disbursement Target" required={true}
            value={newDisbTarget} onChange={onNewDisbTargetChange}
            error={newDisbTargetError} setError={setNewDisbTargetError}
        />

        <InputTextSF type="number" name="numberOfCustomers"
            label="Number of Customers" maxLength={40} required={true} value={numberOfCustomers}
            onChange={onNumberOfCustomersChange} error={numberOfCustomersError} setError={setNumberOfCustomersError}
        />
        </div>
              <div className='cols g_m_right_100'>

                <InputTextSF type="text" name="contactsAchieved" label="Contacts Achieved"
                    maxLength={40} required={true} value={contactsAchieved}
                    onChange={onContactsAchievedChange} error={contactsAchievedError} setError={setContactsAchievedError}
                />
                <InputTextSF type="text" name="newLeadAchieved" label="New Lead Achieved"
                    maxLength={40} required={true} value={newLeadAchieved}
                    onChange={onNewLeadAchievedChange} error={newLeadAchievedError} setError={setNewLeadAchievedError}
                />
                <InputTextSF type="text" name="newDisbAchieved" label="New Disbursement Achieved"
                    maxLength={40} required={true} value={newDisbAchieved}
                    onChange={onNewDisbAchievedChange} error={newDisbAchievedError} setError={setNewDisbAchievedError}
                />
                <InputTextSF type="text" name="customersAchieved" label="Customers Achieved"
                    maxLength={40} required={true} value={customersAchieved}
                    onChange={onCustomersAchievedChange} error={customersAchievedError} setError={setCustomersAchievedError}
                />
            </div>
        </div>
    </ModalFormUI>
);

export default SalesTargetUpdateModalUI;
